import {
    getEmbedMode,
    useIsNativeSignalRConnectionAvailable,
} from "@accurx/native";

/**
 * SignalR can be used via the Native Bridge when the following are true:
 * 1. Embedded in Desktop
 * 2. SignalR via Native Bridge is possible (supported desktop version)
 */
export const useCanUseSignalRViaNativeBridge = (): boolean => {
    const embedMode = getEmbedMode();
    const isNativeSignalRConnectionAvailable =
        useIsNativeSignalRConnectionAvailable();

    return embedMode === "Desktop" && isNativeSignalRConnectionAvailable;
};
